/* istanbul ignore file */
import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  download_nach_form,
  eMandateWebView,
  eSignWebView,
} from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus } from "../../../Redux/Manual_Kyc_Details/action";
import ToastMsg from "../../../helper/ToastMsg";
import { withRouter } from "../../../hooks/withRouter";
import { Loader } from "../Common/Loader";
import { HEADING_AGREEMENT } from "../Common/constant";
const Agreement = (props) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("gpay_token");

  const [state, setState] = useState({
    eMandateUrl: "",
    esign_verified: "",
    emandate_verified: "",
    next_button_apply_loan: false,
    physicalDocEnable: "",
    isChecked: false,
    uploadNachImg: "",
  });
  const [eSignUrl, setESignUrl] = useState("");
  const [isEsignVerified, setEsignVerified] = useState(false);
  const [isEmandateStatus, setisEmandateStatus] = useState(false);
  const [next_button_apply_loan, setNextButtonApplyLoan] = useState(false);
  const [mandateWebViewUrl, setmandateWebViewUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [flag,setFlag]=useState(false)
  const[esignStatus,setEsignStatus]=useState("")
  const[emandateStatus,setEmandateStatus]=useState("")
  let querypram = (new URLSearchParams(window.location.search).get("keyfrom"));
  const [keyfrom, setKeyfrom] = useState(querypram);

  useEffect(() => {
    // console.log(keyfrom,"keyfromkfs");
  
    if (!isEmandateStatus || !isEsignVerified) {
      handleDocumentStatusDetails();
    }
   
    setInterval(() => {
      if (!isEmandateStatus && !isEsignVerified) {
        handleDocumentStatusDetails();
      }
    }, 3000);
  }, []);

  useEffect(() => {
    handleEsignUrl();
  }, []);

  useEffect(()=>{
    
   
   

  },[isEsignVerified,isEmandateStatus])

  const handleDocumentStatusDetails = () => {
    props
      .getDocumentStatus(token)
      .then((res) => {
        setEsignStatus(res.data[0]?.esign_verified)
        setEmandateStatus(res.data[0]?.emandate_verified)
  
        if (res.data[0].esign_verified === "S" ) {
          handleEmandateUrl();
        }
        setEsignVerified(res.data[0].esign_verified === "S" ? true : false);
        setNextButtonApplyLoan(res.data[0].next_button_apply_loan);
        setisEmandateStatus(
          res.data[0].emandate_verified === "S" || res.data[0].emandate_verified === "I" ? true : false
        );
        setEsignStatus(res.data[0]?.esign_verified)
        setEmandateStatus(res.data[0]?.emandate_verified)
       
        setState({
          esign_verified: res.data[0]?.esign_verified,
          emandate_verified: res.data[0]?.emandate_verified,
          physicalDocEnable: res.data[0].physical_nach,
          next_button_apply_loan: res.data[0].next_button_apply_loan,
        });
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const handleEsignUrl = () => {
    setLoader(true);
    props
      .eSignWebView(token)
      .then((res) => {
        setLoader(false);
        eSignUrl;
        setESignUrl(res.data.url);
        if (isEsignVerified) {
          handleEmandateUrl();
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const handleEmandateUrl = () => {
    props
      .eMandateWebView(token)
      .then((res) => {
      
        setmandateWebViewUrl(res.data.url);

        setState({ eMandateUrl: res.data.url }, () => {});
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  const download_nach_form = () => {
    props.download_nach_form(token).then((res) => {
      window.open(res?.config?.url, "_blank");
    });
  };

  const openUrl = () => {
    window.open(eSignUrl);
  };

  const handleChange = (event) => {
    if (state.esign_verified === "S") {
      setState({ isChecked: true });
    } else {
      setState({ isChecked: false });
      // openUrl(eSignUrl)
    }
  };

  const [presigned_urls, setPresigned_urls] = useState({});

  function physicalNachUpload(props) {
    const makeFormData = (result, pdf_value) => {
      let formData = new FormData();
      Object.keys(result.fields).forEach((key) => {
        let value = result.fields[key];
        formData.append(key, value);
      });
      formData.append("file", pdf_value);
      return formData;
    };

    const base64ToByteArray = (base64String) => {
      const byteCharacters = atob(base64String);
      var byteArray = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      return new Uint8Array(byteArray);
    };

    const handlephysicalNachUpload = () => {
      let mediaRequest = {
        allowedMimeTypes: ["application/pdf"],
      };
      window.microapps
        .requestMedia(mediaRequest)
        .then((res) => {
          let fileByteArray = base64ToByteArray(res.bytes);
          let blob = new Blob([fileByteArray], { type: res.mimeType });
          uploadBankStatement(blob);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    };
    useEffect(() => {
      let { id } = props.userDetail && props.userDetail.user_detail;

      handleSignedUrl();
      let data = {
        s3_path: [`physical_nach/${id}/nach.pdf`],
      };
    }, []);

    const handleSignedUrl = () => {
      props
        .preSignedURL({
          s3_path: data,
          token: token,
        })
        .then((res) => {
          // console.log("test upload Document", res);
          setPresigned_urls(res);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
          localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    };

    const uploadBankStatement = (blob) => {
      let { id } = props.userDetail && props.userDetail.user_detail;
      let token = props.token;
      let data = {
        image_path: `physical_nach/${id}/nach.pdf`,
        token: token,
      };
      let bs_presigned_data = state.presigned_urls;
      let bs_data = bs_presigned_data.data[`physical_nach/${id}/nach.pdf`];
      if (bs_presigned_data) {
        let formData = makeFormData(bs_data, blob);
        formData.append("key", data.image_path);
        props
          .uploadDocsToS3({
            url: bs_data.url,
            formData,
          })
          .then((res) => {
            // console.log(res);
            if (res.status === 204) {
              let data = {
                doc_type: "physical_nach",
                path: `physical_nach/${id}/nach.pdf`,
              };
              //   props
              //     .upldateDocumentStatus({
              //       updateStatus: data,
              //       token: token,
              //     })
              //     .then((res) => {
              //       console.log(res);
              //       if (res) {
              //         props.history.push("/complete_your_profile");
              //       }
              //     })
              //     .catch((err) => {
              //       console.log(err);
              //     });
            }
          })
          .catch((err) => {
            setLoader(false);
            if (err.response?.status === 401) {
             window.location.href = "/";
          localStorage.removeItem("gpay_token");
            }
            let error = err?.response?.data?.error;
            ToastMsg(error, "error");
            // console.log(err);
          });
      }
    };
  }

  const uploadImg = (type) => {
    // console.log(type);
    let mediaRequest = {
      allowedMimeTypes: ["image/jpeg"],
    };
    window.microapps
      .requestMedia(mediaRequest)
      .then((res) => {
        let fileByteArray = base64ToByteArray(res.bytes);
        let blob = new Blob([fileByteArray], { type: res.mimeType });
        let imageValue = URL.createObjectURL(blob);
        if (type === "bankStatementimg") {
          setState({
            uploadNachImg: imageValue,
          });
          physicalNachUpload(blob);
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  return (
    <div id="background" className="main_div">
      {loader ? <Loader /> : null}
      <div className="container">
        <div className="pb-4">
          {/* <Heading
            headingText={HEADING_AGREEMENT}
            backprops={"/apply_loan"}
            history={props.history}
          /> */}

          <div className="customheading">
          <img style={{cursor:"pointer", marginLeft:20}} className="customimgfix" src={arrowleft} onClick={() => {
          // window.location.href="/dashboard_s";

          if(keyfrom === "kfs"){
            navigate(-1)
            // navigate("/key-statements");
            return
          }
          navigate(-2)
          return
          // props.history.go(-2)
          }} />
           <h1 className="boldheading" style={{ paddingLeft:"50px", color:'#152745', fontWeight:'800', fontSize:'25px'}}>{HEADING_AGREEMENT}</h1>
          </div>
          
          <div
            className="wrapper-content"
            onClick={() => {
             

              if (isEsignVerified) {
                return;
              } else {
                openUrl(eSignUrl);
              }
            }}
            style={{ cursor: "pointer" }}
            disabled={isEsignVerified}
          >
            <div className="toggle card-height-small w-100 mx-auto bg-grey shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-0 pb-0">
                  <div className="checkbox">
                    <label className="main-check bold">
                      E-Sign
                      {isEsignVerified ? (
                        <div>
                          <input type="checkbox" checked />
                          <span className="geekmark"></span>
                        </div>
                      ) : (
                        <span className="geekmark"></span>
                      )}
                    </label>
                    <p>
                    E-sign helps in getting your loan
                    agreement signed electronically
                    to ensure fast disbursal.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {state.physicalDocEnable ? (
            <div className="wrapper-content">
              <div className="toggle card-height-small w-100 mx-auto bg-grey shadow-lg">
                <div className="h-100 d-flex flex-column justify-content-between">
                  <div className="pt-0 pb-0">
                    <div className="checkbox">
                      <label className="main-check">
                        Physical Nach
                        {/* <input type="checkbox" id="check" /> */}
                        <span className="geekmark"></span>
                      </label>
                      <div className="text-center pt-4 flex space-between">
                        <button
                          className="btn btncolour bg-white rounded-pill e-btn mb-3"
                          style={{marginRight: 8}}
                          onClick={download_nach_form}
                        >
                          Download
                        </button>
                        <button
                          className="btn bg-white rounded-pill e-btn mb-3"
                          // onClick={physicalNachUpload}
                          onClick={() => uploadImg("bankStatementimg")}
                        >
                          Upload
                        </button>
                      </div>
                      <p style={{ paddingLeft: "0px" }}>
                        Thank you for uploading your NACH form. Our team will
                        get it verified within 72 hours.
                      </p>
                      <a href="https://payme-static-document.s3.ap-south-1.amazonaws.com/sample_physical_nach.jpg">
                        Click to view NACH sample form
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="wrapper-content">
              <div
                className="toggle card-height-small w-100 mx-auto bg-grey shadow-lg"
                onClick={() => {
                 
                  if (isEmandateStatus) {
                    return;
                  } else {
                    if (mandateWebViewUrl) {
                      window.open(mandateWebViewUrl, "_blank");
                    }
                  }
                }}
              >
                <div className="h-100 d-flex flex-column justify-content-between">
                  <div className="pt-0 pb-0">
                    <div className="checkbox">
                      <label className="main-check bold">
                        E-mandate
                        {!isEmandateStatus ? (
                          <span className="geekmark"></span>
                        ) : (
                          <div>
                            <input type="checkbox" checked />
                            <span className="geekmark"></span>
                          </div>
                        )}
                      </label>
                      <p>
                      E-mandate enables the automatic debit of the account at the beginning of the billing cycle.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center pt-4">
          {next_button_apply_loan?
          <button
            className="alignbottombtn NbfcBtntext"
            onClick={() => {
             
              window.location.href="/loandetail";
            }}
          >
            Continue
          </button>:
        <button
        className="alignbottombtn NbfcBtntext"
        disabled
        style={{opacity:"50%"}}
      >
        Continue
      </button>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, {
  eSignWebView,
  eMandateWebView,
  getDocumentStatus,
  download_nach_form,
})(Agreement));